import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const HomeScreen = ({ backgroundImage }) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          src={getImageFromS3('images/sms-mrl-prpl/head.gif')}
          alt="head-gif"
          className={styles.headGif}
        />
        <img
          src={getImageFromS3('images/sms-mrl-prpl/head.png')}
          alt="head"
          className={styles.headImage}
        />
        <div className={styles.mainContent}>
          <div className={styles.formatTitle}>У супертонкому форматі</div>
          <div className={styles.tobaccoContainer}>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/tobacco.png')}
              alt="tobacco"
            />
            <div className={styles.textContainer}>
              <p>Оновлена тютюнова суміш</p>
              <p>Вміст смол - 4 мг</p>
            </div>
          </div>
          <div className={styles.filterContainer}>
            <p>
              Ущільнений<br></br> ацетатний<br></br> фільтр
            </p>
            <p>
              Краще тримає<br></br> форму
            </p>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/filter.png')}
              alt="filter"
            />
          </div>
          <div className={styles.qrInsidePackContainer}>
            <p>
              QR-код<br></br> в середині<br></br> пачки
            </p>
            <p>
              Залишити відгук <br></br> Додатковий контент
            </p>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/qrInsidePack.png')}
              alt="qrInsidePack"
            />
          </div>
          <div className={styles.blocksContainer}>
            <p className={styles.title}>
              ТАКОЖ ДОСТУПНИЙ <br></br>У БЛОКАХ
            </p>
            <p className={styles.description}>у фірмовому дизайні</p>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/blocks.png')}
              alt="blocks"
            />
            <img
              src={getImageFromS3('images/sms-mrl-prpl/blocks.gif')}
              alt="blocks-gif"
              className={styles.gif}
            />
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>Де купити?</p>
          <p className={styles.description}>
            Актуальний асортимент можна знайти у роздрібних точках продажу в
            твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <div>
              <a href="/" target="_blank" onClick={() => sendEvent('rozetka')}>
                Rozetka
              </a>
            </div>
            <div>
              <a
                href="/"
                target="_blank"
                onClick={() => sendEvent('Cig-Poshta')}
              >
                Cig-poshta
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-mrl-prpl">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
